import { Box, HStack, Image, IconButton } from '@chakra-ui/react'
import { ConnectedImagesUploader } from 'components/FormElements'
import { Maybe, UploadFile } from 'generated/graphql'
import React from 'react'

import { VscTrash } from 'react-icons/vsc'

const PropertyImages: React.FC<{
  photos?: Maybe<Maybe<UploadFile>[]> | undefined
  setPhotos: React.Dispatch<React.SetStateAction<Maybe<Maybe<UploadFile>[] | undefined>>>
}> = ({ photos, setPhotos }) => {
  return (
    <>
      {photos && (
        <>
          <Box fontSize="sm" fontWeight="bold" mb={2}>
            Current Images
          </Box>

          <HStack overflowY="hidden" spacing={5} py={5} width="100%" overflowX="auto">
            {photos?.map((image) => (
              <Box position="relative" key={image?.id}>
                <IconButton
                  size="sm"
                  position="absolute"
                  top={0}
                  right={0}
                  transform="translate(50%,-50%)"
                  rounded="full"
                  icon={<VscTrash color="red" />}
                  aria-label="remove"
                  onClick={() => {
                    setPhotos((prev) => prev?.filter((p) => p?.id !== image?.id))
                  }}
                />
                <Image
                  src={image?.formats?.thumbnail?.url || image?.url || ''}
                  rounded="md"
                  alt={`Image-${image?.id}`}
                  style={{ maxWidth: '130px', maxHeight: '130px', marginRight: '10px' }}
                />
              </Box>
            ))}
          </HStack>
        </>
      )}
      <ConnectedImagesUploader name="images" label="Property Images" />
    </>
  )
}

export default PropertyImages
